import {disableCesium, getCesium, initCesium} from "@/modules/cesium/cesium";
import {hideActiveToolButtons, toggleActiveToolButton} from "@/helpers/layer-tools-helper";
import {
    addClassBySelector,
    getBySelector,
    hideElementsBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {startTour} from "@/helpers/tour/tour-helper";
import {toggleDrawButtons} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import {View} from "ol";
import {transform} from "ol/proj";
import {showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper.js";

export function toggleCesium() {
    const cesium = getCesium()

    if(cesium === undefined || !cesium.getEnabled()) {
        enableCesium()
    } else {
        stopCesium()
    }
}

export function enableCesium(userSession = undefined) {
    toggleDrawButtons()
    initCesium(false, userSession)

    hideActiveToolButtons()
    document.querySelector('layer-info-tools-3d').classList.remove('d-none')
    document.querySelector('layer-info-tools-measure').classList.add('d-none')

    const element = getBySelector('cesium-enable').querySelector('footer-button')
    // console.log(element.firstChild.firstChild)

    showElementsBySelector('.titleMeasure3D')
    hideElementsBySelector('.titleMeasure')

    getBySelector('layer-info-tools-button').querySelector('.fa').classList.replace('fa-pencil-ruler', 'fa-cube')
    getBySelector('layer-info-tools-button').querySelector('layout-language').innerText = '3D meten en instellingen'
    // startTour(3)

    // element.innerHTML = element.innerHTML.replace('3D', '2D')
    getBySelector('cesium-enable').querySelector('button').classList.add('active')

    showLayerInfoButton('layer-info-tools')
    addClassBySelector('layer-info-tools-button .info-menu-btn', 'active')
}

export function stopCesium() {
    toggleDrawButtons(false)
    disableCesium()

    toggleActiveToolButton(document.querySelector('layer-info-tools-switcher-button'), 'layer-info-tools-draw')

    document.querySelector('layer-info-tools-3d').classList.add('d-none')
    document.querySelector('layer-info-tools-measure').classList.remove('d-none')

    const element = getBySelector('cesium-enable').querySelector('footer-button')
    element.innerHTML = element.innerHTML.replace('2D', '3D')

    getBySelector('cesium-enable').querySelector('button').classList.remove('active')


    hideElementsBySelector('.titleMeasure3D')
    showElementsBySelector('.titleMeasure')
    getBySelector('layer-info-tools-button').querySelector('.fa').classList.replace('fa-cube', 'fa-pencil-ruler')
    getBySelector('layer-info-tools-button').querySelector('layout-language').innerText = 'Tekenen en meten'
}

export function hide2DSettings() {
    const element = getBySelector('layer-info-filter-settings-geometry')
    if(element) {
        element.querySelectorAll('ol-draw-geometry').forEach(element => {
            if (element.dataset.language !== 'fromMap') {
                element.classList.add('d-sm-none')
            }
        })
    }
}

export function show2DSettings() {
    const element = getBySelector('layer-info-filter-settings-geometry')
    if(element) {
        element.querySelectorAll('ol-draw-geometry').forEach(element => {
            element.classList.remove('d-sm-none')
        })
    }
}
